// Filtro de período da visão geral na query string da rota (`spec/17-frontend.md` §3).
//
// Todos os campos são OPCIONAIS de propósito: campo obrigatório em `validateSearch` de
// `/app` torna `search` obrigatório em qualquer `navigate({ to: '/app' })` do painel
// (é o que `/app/terms` faz depois do aceite). O default mora em `resolveRange`.

import { type DatePreset, type DateRangeValue, rangeForPreset } from './period.ts';

export interface OverviewSearch {
  preset?: DatePreset;
  from?: string;
  to?: string;
}

const PRESETS: DatePreset[] = ['today', '7d', '30d', 'custom'];
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

function isPreset(value: unknown): value is DatePreset {
  return typeof value === 'string' && PRESETS.some((preset) => preset === value);
}

function isIsoDate(value: unknown): value is string {
  return typeof value === 'string' && ISO_DATE.test(value);
}

export function validateOverviewSearch(search: Record<string, unknown>): OverviewSearch {
  const out: OverviewSearch = {};
  if (isPreset(search.preset)) {
    out.preset = search.preset;
  }
  if (isIsoDate(search.from)) {
    out.from = search.from;
  }
  if (isIsoDate(search.to)) {
    out.to = search.to;
  }
  return out;
}

/** Default `30d` (item 2 da task); `custom` sem datas cai no mesmo intervalo. */
export function resolveRange(search: OverviewSearch): DateRangeValue {
  const preset = search.preset ?? '30d';
  const base = rangeForPreset(preset === 'custom' ? '30d' : preset);
  return { preset, from: search.from ?? base.from, to: search.to ?? base.to };
}
